import { FC, useEffect } from 'react';
import './RoleInventory.css';
import eFormType from '../../../main/assets/enums/eFormType';
import { useForm } from 'react-hook-form';
import GeneralInput from '../../../main/components/generalInput/GeneralInput';
import React from 'react';
import IRole from '../../../main/interfaces/IRole';
import { ApiConstants } from '../../../main/constants/ApiConstants';
import { toast } from 'react-toastify';
import axiosInstance from '../../../main/initializers/axios';
import { useTranslation } from 'react-i18next';
interface Props {
  tempUser?: any;
  modalType: eFormType;
  onSubmitData: (data: any) => void;
  createOrUpdate: boolean;
  selectedCompanyId?: number;
}

const RoleInventory: FC<Props> = (props: Props) => {
  const { tempUser, modalType, createOrUpdate, selectedCompanyId } = props;

  const { i18n } = useTranslation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IRole>({
    defaultValues: {
      id: modalType === eFormType.Edit ? tempUser?.id : 0,
      code: modalType === eFormType.Edit ? tempUser?.code : '',
      name: modalType === eFormType.Edit ? tempUser?.name : '',
      isAdministrator: modalType === eFormType.Edit ? tempUser?.isAdministrator : false,
      companyId: modalType === eFormType.Edit ? tempUser?.companyId : selectedCompanyId ?? 0,
    },
  });

  const onSubmit = (data: any) => {
    const params = {
      Id: data.id,
      Code: data.code,
      Name: data.name,
      isAdministrator: modalType === eFormType.Edit ? !!tempUser?.isAdministrator : false,
      CompanyId: modalType === eFormType.Edit ? tempUser?.companyId : selectedCompanyId ?? tempUser?.companyId ?? 0,
    };
    axiosInstance.post(ApiConstants.Roles.update, params).then((response) => {
      if (response.status === 200) {
        toast.success(i18n.t('orderDetails.createdSuccessfully'));
        props.onSubmitData(true);
      } else {
        toast.error(i18n.t('orderDetails.somethingWentWrong'));
      }
    });
  };

  useEffect(() => {
    if (createOrUpdate) {
      handleSubmit(onSubmit)();
    }
  }, [createOrUpdate]);

  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-sm-12">
          <div className="form-row formRowCDR">
            <div className="form-group col-md-6 formInputStyle">
              <GeneralInput
                required={false}
                label={i18n.t('generic.code')}
                name="code"
                type="text"
                placeholder={i18n.t('generic.code')}
                errors={errors}
                control={control}
              />
            </div>
            <div className="form-group col-md-6 formInputStyle">
              <GeneralInput
                required={false}
                label={i18n.t('generic.name')}
                name="name"
                type="text"
                placeholder={i18n.t('generic.name')}
                errors={errors}
                control={control}
              />
            </div>
          </div>
          <hr />
        </div>
      </form>
    </div>
  );
};

export default RoleInventory;
